var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000166673790145725697700000004589056116581747092_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,6.2c5.1,0,10.2,0,15.3,0c1.2,0,2.4,0.2,3.5,0.6c2.9,1.2,4.8,3.9,4.8,7c0,6.8,0,13.5,0,20.3c0,4-3.2,7.3-7.2,7.6 c-0.8,0-1.6,0.1-2.4,0.1H8.7c-1.8,0.1-3.5-0.4-5-1.4c-2-1.3-3.2-3.6-3.3-6c-0.1-6.9,0-13.7,0-20.6c0.1-3.9,3.2-7.1,7.1-7.4 c1-0.1,1.9-0.1,2.9-0.1H24z M24,39.3h15.7c2.9,0.2,5.4-2.1,5.5-5c0,0,0,0,0,0c0-6.9,0-13.7,0-20.6c0-1.4-0.7-2.8-1.8-3.7 c-1-0.9-2.4-1.4-3.8-1.3H8.3c-2.9-0.1-5.4,2.1-5.5,5c0,0,0,0.1,0,0.1c0,6.8,0,13.6,0,20.5c0,1.4,0.6,2.8,1.7,3.7 c1,0.9,2.4,1.4,3.8,1.4L24,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,35.1c0-0.3,0.2-0.6,0.4-0.7l5.4-5.2c1.6-1.5,3.1-3,4.7-4.4c0.3-0.2,0.2-0.4,0-0.6l-8-7.8c-0.7-0.7-1.5-1.4-2.2-2.2 c-0.5-0.4-0.6-1.1-0.3-1.5c0-0.1,0.1-0.1,0.1-0.2c0.4-0.5,1.1-0.6,1.6-0.2C7.9,12.3,8,12.4,8,12.4c1.4,1.3,2.8,2.7,4.1,4 c3.8,3.7,7.6,7.4,11.4,11.2c0.4,0.3,0.5,0.3,0.9,0l6.6-6.4c3-2.9,6-5.8,8.9-8.7c0.6-0.6,1.2-0.7,1.8-0.2c0.5,0.3,0.7,1.1,0.3,1.6 c-0.1,0.1-0.1,0.2-0.2,0.2c-0.7,0.7-1.4,1.4-2.1,2.1l-7.9,7.7c-0.5,0.5-0.5,0.5,0,1l9.8,9.3c0.8,0.7,0.7,1.5,0,2 c-0.4,0.3-1,0.3-1.4,0c-0.3-0.3-0.7-0.5-1-0.8c-3.1-2.9-6.2-5.9-9.3-8.8c-0.4-0.4-0.6-0.3-0.9,0c-1.3,1.3-2.5,2.5-3.8,3.8 c-0.9,0.9-1.5,0.9-2.4,0c-1.3-1.3-2.6-2.5-3.8-3.8c-0.3-0.3-0.5-0.3-0.8,0c-2.4,2.3-4.9,4.7-7.3,7l-2.8,2.6 c-0.4,0.4-0.9,0.4-1.4,0.2C6.3,36.1,6,35.6,6,35.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.fdadde8e48d7fbd03d2c8e0ad7b29e26.svg";
export { ForwardRef as ReactComponent };